<template>
    <v-app>
        <slot name="system-bar">
            <AppLayoutSystemBar/>
        </slot>

        <slot name="drawer">

        </slot>

        <slot name="navbar">
            <AppLayoutNavbar/>
        </slot>

        <v-content>
            <slot name="content"></slot>
            <v-container fluid class="fill-height">
                <slot name="main"></slot>
            </v-container>
        </v-content>

        <slot name="footer">
            <AppLayoutFooter/>
        </slot>
    </v-app>
</template>

<script>
    export default {
        name: "app-layout-base"
    }
</script>

<style scoped>

</style>